/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConnectionStatus {
    Unknown = 'unknown',
    CheckingConnection = 'checking_connection',
    DisconnectedIntentional = 'disconnected_intentional',
    Active = 'active'
}


export function instanceOfConnectionStatus(value: any): boolean {
    for (const key in ConnectionStatus) {
        if (Object.prototype.hasOwnProperty.call(ConnectionStatus, key)) {
            if (ConnectionStatus[key as keyof typeof ConnectionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ConnectionStatusFromJSON(json: any): ConnectionStatus {
    return ConnectionStatusFromJSONTyped(json, false);
}

export function ConnectionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectionStatus {
    return json as ConnectionStatus;
}

export function ConnectionStatusToJSON(value?: ConnectionStatus | null): any {
    return value as any;
}

export function ConnectionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ConnectionStatus {
    return value as ConnectionStatus;
}

